/**
 * Small helper class to push queries and responses to LocalStorage.
 *
 * File: \src\stores\LocalStorageStore.ts
 * Created Date: Monday, May 20th 2024, 15:52:00
 * Author: Herrmann Sascha (LDC)
 * -----
 * Last Modified: February 20th 2025, 14:20:10
 * Modified By: Herrmann Sascha (LDC)
 * -----
 * Copyright (c) 2017-2024 Liebherr-Digital Development Center GmbH
 */

export default class LocalStorage {
  private static readonly LS_LANGUAGE_KEY: string = 'procon-language';

  /*
   * LANGUAGE
   */

  /**
   * Gives you back the id of the current chat.
   *
   * @static
   * @return {string}  The conversation ID of the current chat.
   * @memberof LocalStorage
   */
  public static getStoredLanguage(): string {
    const value: string = window.localStorage.getItem(LocalStorage.LS_LANGUAGE_KEY);

    if (!value) {
      return null;
    }

    return value;
  }

  /**
   * Stores a conversation ID. Typically, when the user activates a chat (either by creating a new one
   * or by loading it from the backend, that chat's ID is set in local storage.
   *
   * @static
   * @param {string} conversationId The conversation ID of the current chat.
   * @return {*}  {void}
   * @memberof LocalStorage
   */
  public static storeLanguage(languageCode: string): void {
    if (!languageCode) {
      window.localStorage.removeItem(LocalStorage.LS_LANGUAGE_KEY);
      return;
    }

    window.localStorage.setItem(LocalStorage.LS_LANGUAGE_KEY, languageCode);
  }
}
